import { useEffect, useRef, useState } from 'react';
import MissionHeader from './MissionHeader';
import gsap from 'gsap';
import MainButton from './MainButton';

type DebriefProps = {
    isCorrectAnswer?: boolean | null;
    textDebrief?: string;
    illustrationDebrief?: string;
    handleButtonClick?: () => void;
};

const SELECTORS = {
    imageDebriefFail: '.image-bebe-quiz-fail',
    imageDebriefFinal: '.image-bebe-quizDebrief',
    debriefTitle: '.debrief-titre',
    debriefText: '.debrief-text',
    nextButtonWrap: '.next-question-button-wrap',
};

const Debrief: React.FC<DebriefProps> = ({
    isCorrectAnswer = false,
    textDebrief = '',
    illustrationDebrief = '',
    handleButtonClick = () => {},
}) => {
    const el = useRef<HTMLDivElement>(null);
    const EASE_IN = 'back.out(1.7)';
    const [isAnimating, setIsAnimating] = useState(true);
    const animateDebriefIn = () => {
        const target = [
            SELECTORS.debriefTitle,
            SELECTORS.debriefText,
            SELECTORS.imageDebriefFail,
            SELECTORS.nextButtonWrap,
            SELECTORS.imageDebriefFinal,
        ];

        return gsap.fromTo(
            target,
            { opacity: 0, y: -40 },
            {
                opacity: 1,
                y: 0,
                duration: 0.4,
                ease: EASE_IN,
                stagger: 0.2,
                onComplete: () => {
                    // 🔥 fin de l’anim de debrief → on réactive les boutons
                    setIsAnimating(false);
                },
            },
        );
    };

    useEffect(() => {
        if (el.current) {
            animateDebriefIn();
        }
    }, []);

    return (
        <div
            className={`debrief-container debrief-container-${isCorrectAnswer ? 'correct' : 'wrong'}`}
            ref={el}
        >
            <MissionHeader
                showBackButton={false}
                showCloseButton={true}
                showSettingsButton={false}
                closeButtonVariant='tertiary'
                logoVariant='default'
            />

            <div
                className='debrief-content'
                style={{
                    justifyContent: isCorrectAnswer ? 'flex-start' : 'space-between',
                }}
            >
                <p className='debrief-titre'>
                    {isCorrectAnswer ? 'Bonne réponse' : `Mauvaise réponse`}
                </p>

                {isCorrectAnswer ? (
                    <>
                        <p
                            className='debrief-text'
                            dangerouslySetInnerHTML={{
                                __html: textDebrief.replace(/\n/g, '<br />') || '',
                            }}
                        />
                        <img
                            src={`./images/quiz/${illustrationDebrief || 'bebe-quiz'}.png`}
                            alt='Illustration bébé quiz'
                            className='image-bebe-quizDebrief'
                        />
                    </>
                ) : (
                    <>
                        <img
                            src={`./images/quiz/histoire-1/perdu-2.png`}
                            alt='Illustration bébé quiz'
                            className='image-bebe-quiz-fail'
                        />
                        <p className='debrief-text debrief-wrong-text'>
                            Vous avez mal répondu ! <span>Réessayez !</span>
                        </p>
                    </>
                )}

                <div
                    className='next-question-button-wrap'
                    style={{
                        marginTop: isCorrectAnswer ? '5rem' : '1rem',
                        marginBottom: '1rem',
                        marginInline: 'auto',
                    }}
                >
                    <MainButton
                        text={isCorrectAnswer ? 'Question Suivante' : 'Réessayez'}
                        onClick={handleButtonClick}
                        disabled={isAnimating}
                        backgroundColor={isCorrectAnswer ? 'primary' : 'secondary'}
                    />
                </div>
            </div>
        </div>
    );
};

export default Debrief;
